<button class="popup" *ngIf="_visibility">
  <button class="popup__container" (click)="notificationsSelected()">
    <app-notification-item
      class="popup__content"
      [notification]="notification"
    ></app-notification-item>
    <button class="popup__close" (click)="_visibility = false"></button>
    <footer class="footer d-flex justify-content-end">
      <app-button variant="ghost-primary" size="small">Ver mais</app-button>
    </footer>
  </button>
</button>
